var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button as ChakraButton, Flex } from '@chakra-ui/react';
export const Button = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { variant, background, color, containerWidth = "auto", withIconRight } = rest, otherProps = __rest(rest, ["variant", "background", "color", "containerWidth", "withIconRight"]);
    return (_jsx(Flex, Object.assign({ width: containerWidth, flexWrap: "wrap" }, { children: _jsx(ChakraButton, Object.assign({ rounded: 'full', variant: variant, background: variant === 'whitelabeled' ? background : '', color: variant === 'whitelabeled' ? color : undefined, fontWeight: 'normal', _hover: {
                opacity: '0.7'
            } }, otherProps, { children: children })) })));
};
//# sourceMappingURL=Buttons.js.map